import { useEffect } from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { useChartStore, useSelectOptionsStore } from "../../hooks";
import { LoadingData, ErrorMessage, SelectForm as Select } from "../../ui";

const optionsChart = {
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    // crosshairs: {
    //   fill: {
    //     type: "gradient",
    //     gradient: {
    //       colorFrom: "#D8E3F0",
    //       colorTo: "#BED1E6",
    //       stops: [0, 100],
    //       opacityFrom: 0.4,
    //       opacityTo: 0.5,
    //     },
    //   },
    // },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
    labels: {
      show: true,
    },
  },
  colors: ["#6B94D2"],
};

export const QuestionSatisfactionChart = () => {
  // Datos del hook ----------------------------------------//
  const { isLoading, data, error, filters } = useSelector(
    (state) => state.admin.chart.questionSatisfaction
  );

  const {
    // Props
    satisfactionQuestions,
    months,
    years,

    // Methods
  } = useSelectOptionsStore();

  const { setChartFilter, getDataQuestionSatisfaction } = useChartStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const handleFilterChange = (e, key) => {
    setChartFilter("questionSatisfaction", key, e.target.value);
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!data && filters.month && filters.year && filters.questionId) {
      getDataQuestionSatisfaction(filters);
    }
  }, [data, getDataQuestionSatisfaction, filters]);

  const isAnyLoading = isLoading || satisfactionQuestions.isLoading;

  const errorMessage = error || satisfactionQuestions.error;

  const chartOptions = data
    ? {
        ...optionsChart,
        xaxis: {
          ...optionsChart.xaxis,
          categories: data.categories,
        },
      }
    : optionsChart;

  return (
    <div className="card shadow border-0 h-100">
      <div className="card-body">
        <div className="vstack gap-3">
          <h6 className="mb-0">
            No sólo operamos más rápido, servimos mejor a nuestros pacientes.
          </h6>
          <div className="row gy-2">
            <div className="col-12 col-xl-6">
              <Select
                label={"Pregunta"}
                name={"questionId"}
                options={satisfactionQuestions.data}
                labelKey={"name"}
                onInputChange={(e) => handleFilterChange(e, "questionId")}
                value={filters.questionId}
              />
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <Select
                label={"Mes"}
                name={"month"}
                options={months.data}
                labelKey={"label"}
                onInputChange={(e) => handleFilterChange(e, "month")}
                value={filters.month}
              />
            </div>
            <div className="col-12 col-md-6 col-xl-3">
              <Select
                label={"Año"}
                name={"year"}
                options={years.data}
                labelKey={"label"}
                onInputChange={(e) => handleFilterChange(e, "year")}
                value={filters.year}
              />
            </div>
          </div>

          {isAnyLoading && <LoadingData />}
          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

          {data && (
            <Chart
              options={chartOptions}
              series={data.series}
              type="bar"
              width="100%"
              height={350}
            />
          )}
        </div>
      </div>
    </div>
  );
};
